import "./ViewCollectionButton.css";

export function ViewCollectionButton(props) {
    return (
        <div className="view-collection-btn-container">
            <div className="view-collection-txt">
                View the Collection
            </div>
        </div>
    )
}
